/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SingleProductMedia } from './single-product-media';
/**
 * 
 * @export
 * @interface ProductVariant
 */
export interface ProductVariant {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    sku: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    upc: string;
    /**
     * 
     * @type {Array<SingleProductMedia>}
     * @memberof ProductVariant
     */
    media: Array<SingleProductMedia>;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    retailPrice: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    finalPrice: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductVariant
     */
    isDiscounted: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    discountAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    inventoryCount: number;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    inventoryStatus: ProductVariantInventoryStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    totalSold: number;
    /**
     * Width in inches
     * @type {number}
     * @memberof ProductVariant
     */
    width: number;
    /**
     * Height in inches
     * @type {number}
     * @memberof ProductVariant
     */
    height: number;
    /**
     * Length in inches
     * @type {number}
     * @memberof ProductVariant
     */
    length: number;
    /**
     * Weight in oz
     * @type {number}
     * @memberof ProductVariant
     */
    weight: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductVariant
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ProductVariant
     */
    inventoryLastUpdated: Date;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    discount: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductVariantInventoryStatusEnum {
    INSTOCK = 'IN_STOCK',
    OUTOFSTOCK = 'OUT_OF_STOCK',
    LOWSTOCK = 'LOW_STOCK'
}

